<div class="benefits-hero" #benefitsHero data-section-id="benefits-hero-section" data-section-name="Benefits Hero">

  <div class="benefits-hero__content ocultarMobile">
    <img src="https://www.unipay.cl/api/descargaArchivo/banner2-beneficios-xl.png" alt="Beneficios Unipay"
      class="benefits-hero__image ocultarMobile" />
  </div>
  <div class="benefits-hero__content ocultarDesktop">
    <img src="https://www.unipay.cl/api/descargaArchivo/banner2-beneficios-movil.png"
      alt="Beneficios Unipay" class="benefits-hero__image" />
  </div>

</div>
